import { render, staticRenderFns } from "./product-action-card.vue?vue&type=template&id=14bf20b5"
import script from "./product-action-card.vue?vue&type=script&lang=ts"
export * from "./product-action-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports